<template>
  <div>
    <v-card>
      <v-toolbar dense color="grey lighten-3" flat>
        <v-icon>mdi-magnify</v-icon>
        <v-toolbar-title>{{ header }} Helplist</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn text icon @click="doSelect">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-flex xs12>
          <v-card>
            <v-card-text>
              <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
              <!-- <v-data-table v-bind:headers="headers" v-bind:items="items" v-bind:search="search" :footer-props="{'items-per-page-options': itemsPerPage }"
                v-bind:options.sync="pagination" item-key="id" :loading="loading" :no-data-text="noDataText" :custom-filter="customSearch" v-model="selected">
                <template v-slot:item="row">
                  <td style="width:50px">
                    <v-checkbox primary hide-details v-model="row.selected" @change="collectItems($event, row.item.id)"></v-checkbox>
                  </td>
                  <td class="text-xs-left">{{ row.item.id }}</td>
                  <td class="text-xs-left">{{ row.item.desc }}</td>
                </template>
              </v-data-table> -->
              <v-data-table
              :headers="headers"
              :items="items"
              :loading="loading"
              :custom-filter="customSearch"
              :no-data-text="noDataText"
              item-key="key"
              show-select
              v-bind:search="search"
              v-model="selected"
              @input="enterSelect"
              @toggle-select-all="enterSelectAll(pagination, items, selected)"
              >
              </v-data-table>
              <div v-if="checkedItems.length === 0" class="small font-weight-light grey--text">Note: Default is "All" if no item is selected. </div>
              <v-textarea v-if="checkedItems.length > 0" label="Selected Items" v-model="checkedItems" rows="1" readonly></v-textarea>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green" dark class="mb-2" @click="doSelect('All', 'insured')">
                Select All
                <v-icon right>mdi-check-all</v-icon>
              </v-btn>
              <v-btn color="info" dark class="mb-2" @click.prevent="doReset">
                Reset
                <v-icon dark right>mdi-refresh</v-icon></v-btn>
              <v-btn color="primary" dark class="mb-2" @click="doSelect('', 'insured')">
                Select
                <v-icon right>mdi-check</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { helpListMixin } from '@/mixins/common/helpListMixin'
import MessageMixin from '@/mixins/message'
export default {
  props: {
    'apiURI': String,
    'mode': String,
    'param': String
  },
  data() {
    return {
      headers: [
        { text: 'Branch', value: 'id' },
        { text: 'Description', value: 'desc' }
      ],
      header: '',
      selected: [],
      parameter: [],
      items: [],
      paramItems: []
    }
  },
  watch: {
    'mode': function (value) {
      this.doInit()
      this.getLabel()
    },
    'param': function (value) {
      this.doInit()
      this.getLabel()
    }
  },
  created() {
    this.doInit()
    this.getLabel()
  },
  methods: {
    doInit() {
      this.parameter = this.param.split(',')
      const apiURI = this.apiURI
      if (apiURI) {
        if (this.parameter !== this.checkedItems) {
          // CBO: to reset the 'this.checkedItems' if called from different mode
          this.doReset()
          this.checkedItems = this.parameter
        }
        this.loading = true
        this.$http.get(apiURI).then(result => {
          this.items = []
          this.selectedItems = []
          const { data } = result.data
          if (data) {
            data.map(param => {
              const convertList = {
                key: param.value,
                id: param.value,
                desc: param.label
              }
              if (this.checkedItems.includes(param.value)) {
                const paramList = {
                  key: param.value,
                  id: param.value,
                  desc: param.label
                }
                this.selectedItems.push(paramList)
              }
              this.items.push(convertList)
            })
          }
          if (this.checkedItems.toString() === 'All') {
            this.doReset()
            this.toggleAll()
          } else {
            this.toggleSelected()
          }
          this.loading = false
        }).catch(err => {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        })
      }
    },
    getLabel() {
      this.headers = []
      // Push a header with empty text for checkboxes
      switch (this.mode) {
        case 'branch': this.headers.push({ text: 'Branch', value: 'id' })
          this.header = 'Branch'
          break
        case 'homeBrn': this.headers.push({ text: 'Home Branch', value: 'id' })
          this.header = 'Home Branch'
          break
        case 'fund': this.headers.push({ text: 'Fund', value: 'id' })
          this.header = 'Fund'
          break
        case 'suffix': this.headers.push({ text: 'Suffix', value: 'id' })
          this.header = 'Suffix'
          break
        case 'interType': this.headers.push({ text: 'Intermediary Type', value: 'id' })
          this.header = 'Intermediary Type'
          break
        case 'curr': this.headers.push({ text: 'Currency', value: 'id' })
          this.header = 'Currency'
          break
        case 'excludeTranType': this.headers.push({ text: 'Transaction Type', value: 'id' })
          this.header = 'Exclude Transaction Type'
          break
        case 'gstStatus': this.headers.push({ text: 'GST Status', value: 'id' })
          this.header = 'GST Status'
          break
        case 'bankNo': this.headers.push({ text: 'Bank No.', value: 'id' })
          this.header = 'Bank No.'
          break
      }
      this.headers.push({ text: 'Description', value: 'desc' })
    }
  },
  mixins: [
    TableConst.default,
    MessageMixin,
    helpListMixin
  ]
}
</script>

<style>
</style>
